/**
 * Supabase implementation of EmailAdapter.
 * Delegates to the send-alert-email Edge Function (Resend-backed).
 */

import { createClient } from '@/lib/supabase/client';
import type { EmailAdapter, EmailPayload, EmailResult } from '../interfaces';

export class SupabaseEmailAdapter implements EmailAdapter {
  async sendAlert(payload: EmailPayload): Promise<EmailResult> {
    try {
      const supabase = createClient();
      const { error } = await supabase.functions.invoke('send-alert-email', {
        body: { type: payload.type, to: payload.to, data: payload.data },
      });
      if (error) {
        console.error('[SupabaseEmail] sendAlert:', error.message);
        return { success: false, error: error.message };
      }
      return { success: true };
    } catch (e: any) {
      console.error('[SupabaseEmail] sendAlert exception:', e.message);
      return { success: false, error: e.message };
    }
  }
}
